<template lang="pug">
  span.btn.flex.relative.hover-z-10(@click="$emit('click')", :class="[clss, height, fontSize]")
    //- span(:class="fz")
    slot
</template>

<script>
export default {
  name: 'Btn',
  props: ['active', 'type', 'theme', 'disabled'],
  computed: {
    height () {
      return this.is('hero-cta,slim') ? 'h-30 pt-1'
        : this.is('submit,close') ? 'h-50 md-h-40'
          : this.is('filter-reset') ? 'h-40 md-h-30'
            : 'h-40 pt-2'
    },
    fontSize () {
      return this.is('hero-cta') ? 'text-11 md-text-13'
        : 'text-13'
    },
    clss () {
      return {
        // 'cursor-pointer': !this.disabled,
        // default style
        'border bordery-gray-300': !this.theme,
        'text-blue z-10 border-current': this.active && !this.theme,
        'hover-text-blue hover-border-current': !this.theme && !this.disabled,
        // themes
        '': this.theme === 'inherit'
      }
    }
  },
  methods: {
    is (list = '') {
      return list.split(',').includes(this.type)
    }
  }
}
</script>

<style>
  .btn {
    @apply items-center justify-center leading-none px-15
  }
</style>
